import React, { useEffect, useState, useMemo, useRef } from "react";
import { UmbracoStep } from "components/Umbraco/UmbracoContext";
import utils from "utils";
import {
  CheckBox,
  CheckValidInputs,
  LabelError,
  MainCond,
  Spinner,
  StepBody,
  StepFooter,
  useInput,
} from "meitav-uikit";
import { pdfjs, Document, Page } from "react-pdf";
import { Parser } from "html-to-react";
import { postData, setDataLayer } from "../../../../../utils/Functions";
import { isMobile } from "react-device-detect";
import Footer from "components/Footer";
import "./step44.scss";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
//pdfjs.GlobalWorkerOptions.workerSrc = "node_modules/pdfjs-dist/build/pdf.worker.mjs";
//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.mjs"; //
const { UmbracoUtills, rest } = utils;

export default function Step44({
  resource,
  model,
  setModel,
  setStep,
  step,
  nextText,
  resourceError,
  disable,
}) {
  const p = new Parser();
  const resourceStep = UmbracoStep(resource, `ThirdSub44Step`);
  const [dataPdf, setDataPdf] = useState([]);
  const [scale, setScale] = useState(1.4);
  const [numPages, setNumPages] = useState(null);
  const [firstTime, setFirstTime] = useState(true);
  const [disableCheckBox, setDisableCheckBox] = useState(
    !model?.specialRiskDocument
  );
  const [checkSpecialRiskDocument, setCheckSpecialRiskDocument] = useState(
    model?.specialRiskDocument
  );
  const pdfContainerRef = useRef(null);

  useEffect(() => {
    GetPdfDigitalCoin();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!pdfContainerRef.current) return;

      const { scrollTop, scrollHeight, clientHeight } = pdfContainerRef.current;

      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setDisableCheckBox(false);
      }
    };

    const container = pdfContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const GetPdfDigitalCoin = async () => {
    rest.get(`/api/Manager/GetPdfDigitalCoin`).then((res) => {
      if (res && res.data) {
        const binaryString = window.atob(res.data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
          var ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        setDataPdf([...bytes]);
        setFirstTime(true);
        if (isMobile) {
          if (window.innerWidth <= 390) setScale(0.6);
          else if (window.innerWidth <= 414) setScale(0.7);
          else if (window.innerWidth <= 500) setScale(0.8);
          else if (window.innerWidth <= 600) setScale(0.9);
          else if (window.innerWidth <= 700) setScale(1);
          else if (window.innerWidth <= 800) setScale(1.1);
        }
      }
    });
  };

  const memoizedFile = useMemo(() => ({ data: dataPdf }), [dataPdf]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setLoadingSuccess(true);
  }
  function onDocumentLoadError(e) {
    console.error("load pdf fail: ", e);
    //setShowSpinner(false);
  }
  const handleNext = async () => {
    if (!checkSpecialRiskDocument) {
      setStep(44);

      return;
    }

    setDataLayer(
      "PM - declarations",
      window.location.pathname,
      "מסמכים והצהרות",
      "המשך מוצלח של הסכם לניהול תיק השקעות"
    );

    let tmpModel = model;
    tmpModel.currentStepID = 44;
    tmpModel.stepID = 43;
    tmpModel.specialRiskDocument = checkSpecialRiskDocument;
    postData(tmpModel, setStep);
  };

  const handlePrev = async () => {
    setDataLayer(
      "PM - Levels",
      "/JoinPersonalDetails",
      "חזור לשלב הקודם",
      "חזרה - " + step
    );

    let tmpModel = model;
    setModel(tmpModel);
    setStep(42);
  };
  const [LoadingSuccess, setLoadingSuccess] = useState(false);
  const onLoadingSucess = () => {
    setLoadingSucess(true);
  };

  const handleChange = async () => {
    setCheckSpecialRiskDocument(!checkSpecialRiskDocument);
  };
  return (
    <>
      <StepBody>
        <div className="pdfAgreement" ref={pdfContainerRef}>
          {dataPdf.length > 0 ? (
            <>
              <Document
                file={memoizedFile}
                //loading={LoadingSuccess ? null:<Spinner /> }
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    scale={scale}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                ))}
              </Document>
            </>
          ) : (
            <Spinner />
          )}
        </div>
        <CheckBox
          id="specialRiskDocument"
          disable={disableCheckBox}
          value={checkSpecialRiskDocument}
          className={disableCheckBox ? "Checkbox-Uikit-disabled" : ""}
          label={UmbracoUtills.getValueByKey(resourceStep, "checkAgreement")}
          onChange={handleChange}
        />
      </StepBody>
      <StepFooter
        nextText={nextText}
        handleNext={handleNext}
        handlePrev={handlePrev}
      />
      <Footer
        text={p.parse(UmbracoUtills.getValueByKey(resourceStep, "mainText"))}
      ></Footer>
    </>
  );
}
